// Mock data for MOS Veteran & MOS Academy website

// MOS Veteran Organization Data
export const organizationData = {
  mission: "Empowering Veterans, Families, and Communities Through Mastery, Purpose, and Opportunity",
  tagline: "Mastery of Self™",
  vision: "To help individuals reclaim their identity, purpose, and power through self-mastery, education, and hands-on vocational experiences. MOS Veteran is more than a nonprofit — it's an ecosystem built to transform lives through learning, community, and legacy.",
  values: ["Mastery", "Opportunity", "Service"],
  focus: "ecosystem" // Two-track system
};

export const founderData = {
  name: "Torey Crawford",
  title: "Founder",
  quote: "At MOS, we don't just build skills — we build purpose. My mission is to help veterans, spouses, and dependents channel the same discipline, resilience, and strength that carried them through service into building something greater — businesses, careers, and legacies that last.",
  bio: "After years of serving and standing shoulder-to-shoulder with the military community, I realized that many of us weren't just looking for a new job — we were searching for a new mission. MOS Academy was born from that vision: to create a space where our experiences become empowerment, where our stories turn into success, and where we continue to lead — not in uniform, but in life.\n\nThis is more than a program. It's a movement to help every veteran rise, rebuild, and redefine what's possible after service.",
  image: null // No image
};

export const teamMembers = [
  // Team pending - to be added later
];

export const testimonials = [
  {
    id: 1,
    name: "David Thompson",
    role: "U.S. Army Veteran",
    text: "Mastery of Self helped me rediscover my purpose after leaving the service. The mentorship and community support gave me the confidence to start my own business and build a new identity in civilian life.",
    program: "Veteran Services"
  },
  {
    id: 2,
    name: "Maria Santos",
    role: "Military Spouse",
    text: "As a military spouse, finding meaningful career support was challenging. MOS Veteran changed everything for my family by connecting us with resources and a community that truly understands our journey.",
    program: "Veteran Services"
  },
  {
    id: 3,
    name: "Kevin Brown",
    role: "U.S. Marine Corps Veteran",
    text: "The transition from military to civilian life was one of the hardest challenges I faced. MOS helped me understand that I wasn't losing my identity—I was reclassifying it. Now I'm thriving in my new career.",
    program: "Veteran Services"
  }
];

// MOS Academy Barber School Data
export const academyData = {
  title: "MOS Academy Barber School",
  tagline: "Launching 2026",
  description: "We're launching a comprehensive barber training program for the military community. Set to officially launch in 2026, this program will provide hands-on instruction, licensing preparation, and mentorship from industry professionals - specifically designed for veterans, military spouses, and dependents worldwide.",
  duration: "Pending",
  certification: "Pending",
  status: "upcoming", // Indicates this is a new/upcoming program
  launchDate: "2026",
  features: [
    "Hands-on training with professional equipment",
    "Licensing exam preparation and support",
    "One-on-one instructor mentorship",
    "Business development and entrepreneurship training",
    "Job placement assistance",
    "Post-graduation support and community"
  ],
  heroImage: "https://images.unsplash.com/photo-1759134198561-e2041049419c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXJiZXJzaG9wfGVufDB8fHx8MTc2MTA1NTUxMXww&ixlib=rb-4.1.0&q=85",
  images: [
    "https://images.unsplash.com/photo-1759134198561-e2041049419c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXJiZXJzaG9wfGVufDB8fHx8MTc2MTA1NTUxMXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1758732461536-90cd5033a4d2",
    "https://images.unsplash.com/photo-1759134248487-e8baaf31e33e",
    "https://images.pexels.com/photos/3993442/pexels-photo-3993442.jpeg"
  ]
};

// Track 1: Personal Mastery & Development
export const track1Data = {
  title: "Track 1: Personal Mastery & Development",
  subtitle: "Read to Reclaim",
  tagline: "Books • Mindset • Reflection",
  description: "This is the mental and emotional transformation arm of M.O.S., focused on inner growth, literacy, and purpose discovery. Participants build confidence and clarity through guided reading, reflection, and conversation.",
  programs: [
    {
      id: 1,
      title: "MOS Book Box",
      icon: "book-open",
      description: "Curated book bundles with reflection tools, journals, and M.O.S. branded items."
    },
    {
      id: 2,
      title: "Virtual & Live Discussions",
      icon: "message-circle",
      description: "Interactive workshops, community summits, and literary deep dives."
    },
    {
      id: 3,
      title: "Peer Mentorship & Coaching Circles",
      icon: "users",
      description: "Small-group mentorship connecting veterans, spouses, and community members."
    },
    {
      id: 4,
      title: "MOS Summit",
      icon: "award",
      description: "Annual event (in-person or virtual) highlighting mindset, healing, finances, and purpose — featuring speakers from veteran, wellness, and literary circles."
    },
    {
      id: 5,
      title: "MOS Circle",
      icon: "heart",
      description: "A monthly community of givers and sponsors who fund book boxes and support growth programs, with optional workshops and peer discussions."
    }
  ],
  image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?q=80&w=2000"
};

// Track 2: Mastery Through Trade
export const track2Data = {
  title: "Track 2: Mastery Through Trade",
  subtitle: "Mastery Through Trade",
  tagline: "Skill • Structure • Self-Reliance",
  description: "This is the vocational and economic empowerment arm of M.O.S., giving individuals — especially veterans and underserved communities — the tools to build skills, income, and self-sufficiency through the barbering trade.",
  programs: [
    {
      id: 1,
      title: "MOS Academy",
      icon: "scissors",
      description: "Licensed curriculum offered in partnership with accredited institutions. Discounted tuition for veterans and dependents. Scholarships funded by nonprofit donors and sponsors.",
      launchDate: "2026"
    },
    {
      id: 2,
      title: "Life Skills Through the Chair",
      icon: "briefcase",
      description: "Soft-skill development embedded into every training module: communication, professionalism, time management, and confidence building. Guest speakers and entrepreneurs teach wealth creation, branding, and self-discipline."
    },
    {
      id: 3,
      title: "Job Placement + Apprenticeship Track",
      icon: "trending-up",
      description: "Partnerships with barbershops and salons for guaranteed post-graduation placement. Includes re-entry support for veterans and individuals transitioning from hardship."
    }
  ],
  images: [
    "https://images.unsplash.com/photo-1759134198561-e2041049419c",
    "https://images.unsplash.com/photo-1758732461536-90cd5033a4d2",
    "https://images.unsplash.com/photo-1759134248487-e8baaf31e33e"
  ]
};
export const veteranServicesData = {
  title: "Veteran Empowerment Services",
  tagline: "Build. Connect. Thrive.",
  description: "Comprehensive support services including career coaching, entrepreneurship mentorship, and community-building events for the entire veteran and military family network.",
  services: [
    {
      title: "Career Coaching",
      description: "One-on-one career guidance and professional development support",
      icon: "briefcase"
    },
    {
      title: "Entrepreneurship Mentorship",
      description: "Business planning, funding guidance, and startup support",
      icon: "trending-up"
    },
    {
      title: "Networking Events",
      description: "Monthly gatherings connecting veterans with local businesses",
      icon: "users"
    },
    {
      title: "Resource Connections",
      description: "Access to housing, healthcare, and family support services",
      icon: "link"
    }
  ],
  images: [
    "https://images.pexels.com/photos/7467919/pexels-photo-7467919.jpeg",
    "https://images.pexels.com/photos/7467859/pexels-photo-7467859.jpeg",
    "https://images.unsplash.com/photo-1590650046871-92c887180603",
    "https://images.unsplash.com/photo-1758599543132-ba9b306d715e"
  ]
};

export const events = [
  {
    id: 1,
    title: "MOS Academy Cohort 3 Enrollment",
    date: "March 15, 2025",
    time: "Application Deadline",
    location: "Online Application",
    type: "enrollment",
    description: "Join our next cohort starting April 2025. Limited spots available for veterans, military spouses, and dependents.",
    image: "https://images.unsplash.com/photo-1543697506-6729425f7265?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxiYXJiZXIlMjB0cmFpbmluZ3xlbnwwfHx8fDE3NjEwNTU1MTd8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Veteran Networking Night",
    date: "February 28, 2025",
    time: "6:00 PM - 9:00 PM CET",
    location: "Community Center, Kaiserslautern",
    type: "networking",
    description: "Connect with fellow veterans, military families, and local business owners. Free event with refreshments.",
    image: "https://images.unsplash.com/photo-1590650046871-92c887180603"
  },
  {
    id: 3,
    title: "MOS Pop-Up at Ramstein AB",
    date: "February 14, 2025",
    time: "10:00 AM - 4:00 PM",
    location: "Ramstein Air Base",
    type: "community",
    description: "Free haircuts and information sessions. Meet our instructors and learn about our programs.",
    image: "https://images.unsplash.com/photo-1759134198561-e2041049419c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXJiZXJzaG9wfGVufDB8fHx8MTc2MTA1NTUxMXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Entrepreneurship Workshop",
    date: "March 5, 2025",
    time: "2:00 PM - 5:00 PM CET",
    location: "MOS Headquarters",
    type: "workshop",
    description: "Learn the fundamentals of starting your own business. Open to all veteran family members.",
    image: "https://images.pexels.com/photos/7467919/pexels-photo-7467919.jpeg"
  }
];

export const newsArticles = [
  {
    id: 1,
    title: "MOS Academy Celebrates First Graduating Cohort",
    date: "January 15, 2025",
    category: "Academy",
    excerpt: "Our inaugural class of 12 students successfully completed the barber training program, with 100% passing their licensing exams.",
    image: "https://images.unsplash.com/photo-1592304346250-ef7244f8c9cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxiYXJiZXIlMjB0cmFpbmluZ3xlbnwwfHx8fDE3NjEwNTU1MTd8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Partnership Announced with Ramstein Air Base",
    date: "December 20, 2024",
    category: "Community",
    excerpt: "MOS partners with Ramstein AB to provide on-base services and training opportunities for active duty members and families.",
    image: "https://images.pexels.com/photos/7467859/pexels-photo-7467859.jpeg"
  },
  {
    id: 3,
    title: "Veteran Success Story: From Student to Business Owner",
    date: "November 30, 2024",
    category: "Success Story",
    excerpt: "Meet David Thompson, who transformed his MOS Academy training into a thriving barbershop in Kaiserslautern.",
    image: "https://images.unsplash.com/photo-1759134198561-e2041049419c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXJiZXJzaG9wfGVufDB8fHx8MTc2MTA1NTUxMXww&ixlib=rb-4.1.0&q=85"
  }
];

export const enrollmentSteps = [
  {
    step: 1,
    title: "Check Eligibility",
    description: "Open to U.S. veterans, military spouses, DoD civilians, and dependents stationed in the KMC area."
  },
  {
    step: 2,
    title: "Submit Application",
    description: "Complete our online enrollment form with your contact information and military affiliation."
  },
  {
    step: 3,
    title: "Schedule Interview",
    description: "Meet with our team to discuss your goals and learn more about the program."
  },
  {
    step: 4,
    title: "Begin Your Journey",
    description: "Join the next cohort and start building your future."
  }
];

// Mock form submission handlers
export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', formData);
      resolve({ success: true, message: 'Thank you! We will contact you soon.' });
    }, 1000);
  });
};

export const submitEnrollmentForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Enrollment form submitted:', formData);
      resolve({ success: true, message: 'Application received! We will be in touch shortly.' });
    }, 1000);
  });
};

export const subscribeNewsletter = (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Newsletter subscription:', email);
      resolve({ success: true, message: 'Successfully subscribed to our newsletter!' });
    }, 1000);
  });
};

export const processDonation = (amount) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Donation processed:', amount);
      resolve({ success: true, message: 'Thank you for your generous donation!' });
    }, 1000);
  });
};